// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__lIYv3","savePackageButton":"ClientWallet_savePackageButton__2WXw_"};